<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  label: string;
  timeLeft: number;
  formatted: string;
  subtext?: string;
}>();

const isUrgent = computed(() => {
  const ms = props.timeLeft;
  return ms >= 60 * 1000 && ms < 15 * 60 * 1000;
});

const isPulseAnimation = computed(() => {
  const ms = props.timeLeft;
  return ms < 60 * 1000;
});
</script>

<template>
  <div
    class="px-4 sm:px-6 pt-0 pb-2 sm:pb-3"
    role="timer"
    aria-live="polite"
    aria-atomic="true"
  >
    <div
      class="px-4 sm:px-6 py-4 sm:py-5 text-center rounded-lg border-2 border-emerald-200 dark:border-emerald-900 bg-gradient-to-r from-emerald-50/80 to-green-50/80 dark:from-emerald-950/40 dark:to-green-950/40"
      :class="{
        'ring-2 ring-emerald-300/50 dark:ring-emerald-700/50': isPulseAnimation,
        'animate-pulse motion-reduce:animate-none': isPulseAnimation,
      }"
    >
      <div
        v-if="label"
        class="text-sm sm:text-base font-semibold text-emerald-900 dark:text-emerald-100 tracking-wide"
        :class="{ 'mb-2 sm:mb-3': formatted }"
      >
        {{ label }}
      </div>
      <div
        v-if="formatted"
        class="text-3xl sm:text-4xl font-bold font-mono text-emerald-700 dark:text-emerald-200 tracking-wider"
      >
        {{ formatted }}
      </div>
      <p
        v-if="subtext"
        class="mt-2 text-xs sm:text-sm font-normal text-emerald-800/80 dark:text-emerald-200/70"
      >
        {{ subtext }}
      </p>
    </div>
  </div>
</template>
